import React from 'react'
import { FormattedMessage } from 'react-intl'
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor'
import logo from './../assets/logo/logo-blanco.svg'
//import { NavLink } from "react-router-dom";
import { NavHashLink as NavLink } from 'react-router-hash-link'
import { injectIntl } from 'react-intl'

class Header extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            press: false
        }
    }

    clickWrapperMenu = () => {
        if (window.innerWidth < 1024) {
            this.setState({
                press: !this.state.press
            })
            document.body.classList.toggle('body__fixed')
        }
    }

    removeBodyFixed = () => {
        document.body.classList.remove('body__fixed')
    }

    render() {
        /* configureAnchors({ offset: -80, scrollDuration: 700 }); */
        return (
            <header className={this.state.press ? 'header__dark' : 'header'}>
                <div className="container">
                    <nav role="navigation" className="header__nav__mobile">
                        <div className={this.state.press ? 'wrapper-menu open' : 'wrapper-menu'} onClick={this.clickWrapperMenu}>
                            <div className="line-menu half start" />
                            <div className="line-menu" />
                            <div className="line-menu half end" />
                        </div>
                    </nav>
                    <NavLink smooth to={`${this.props.intl.formatMessage({ id: '_ROUTE_HOME' })}#start`} className="header__logo" onClick={this.removeBodyFixed}>
                        <img className="logo__img" src={logo} alt="Logotipo Seyte" />
                    </NavLink>
                    <div className="header__language">
                        <a href="/#start">
                            <span class="flag-icon flag-icon-es" />
                        </a>
                        <a href="/en#start">
                            <span class="flag-icon flag-icon-gb" />
                        </a>
                        <a href="/pt#start">
                            <span class="flag-icon flag-icon-pt" />
                        </a>
                    </div>
                    <nav role="navigation" className="header__nav">
                        <ul className={this.state.press ? 'nav__navigation navigation-open' : 'nav__navigation'} style={{ textTransform: 'uppercase' }}>
                            <li className="nav__item">
                                <NavLink
                                    href="/"
                                    to={`${this.props.intl.formatMessage({ id: '_ROUTE_HOME' })}#section__info`}
                                    scroll={el =>
                                        el.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                            inline: 'start'
                                        })
                                    }
                                    className={this.state.press ? 'nav__item__active' : ''}
                                    onClick={this.clickWrapperMenu}
                                >
                                    <FormattedMessage id="inicio" defaultMessage="INICIO" />
                                </NavLink>
                            </li>
                            <li className="nav__item">
                                <NavLink
                                    to={`${this.props.intl.formatMessage({ id: '_ROUTE_HOME' })}#section__ventajas`}
                                    scroll={el =>
                                        el.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                            inline: 'start'
                                        })
                                    }
                                    className={this.state.press ? 'nav__item__active' : ''}
                                    onClick={this.clickWrapperMenu}
                                >
                                    <FormattedMessage id="ventajas" defaultMessage="VENTAJAS" />
                                </NavLink>
                            </li>
                            <li className="nav__item">
                                <NavLink
                                    to={`${this.props.intl.formatMessage({ id: '_ROUTE_HOME' })}#section__funcionamiento`}
                                    scroll={el =>
                                        el.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                            inline: 'start'
                                        })
                                    }
                                    className={this.state.press ? 'nav__item__active' : ''}
                                    onClick={this.clickWrapperMenu}
                                >
                                    <FormattedMessage id="funcionamiento" defaultMessage="FUNCIONAMIENTO" />
                                </NavLink>
                            </li>
                            <li className="nav__item">
                                <NavLink
                                    to={`${this.props.intl.formatMessage({ id: '_ROUTE_HOME' })}#section__distribuidor`}
                                    scroll={el =>
                                        el.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                            inline: 'start'
                                        })
                                    }
                                    className={this.state.press ? 'nav__item__active' : ''}
                                    onClick={this.clickWrapperMenu}
                                >
                                    <FormattedMessage id="section__distribuidor" defaultMessage="DISTRIBUIDORES" />
                                </NavLink>
                            </li>
                            <li className="nav__item" style={{ textTransform: 'none' }}>
                                <NavLink
                                    to={`${this.props.intl.formatMessage({ id: '_ROUTE_HOME' })}#section__faq`}
                                    scroll={el =>
                                        el.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                            inline: 'start'
                                        })
                                    }
                                    className={this.state.press ? 'nav__item__active' : ''}
                                    onClick={this.clickWrapperMenu}
                                >
                                    <FormattedMessage id="faq" defaultMessage="FAQs" />
                                </NavLink>
                            </li>
                            <li className="nav__item">
                                <NavLink
                                    to={`${this.props.intl.formatMessage({ id: '_ROUTE_HOME' })}#section__distribuidor`}
                                    scroll={el =>
                                        el.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                            inline: 'start'
                                        })
                                    }
                                    className={this.state.press ? 'nav__item__active nav__item--blue' : 'nav__item--blue'}
                                    onClick={this.clickWrapperMenu}
                                >
                                    <FormattedMessage id="contacto" defaultMessage="CONTACTO" />
                                </NavLink>
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
        )
    }
}

export default injectIntl(Header)



// WEBPACK FOOTER //
// ./src/components/Header.js